import classNames from 'classnames';
import { Dispatch, ReactNode, SetStateAction, SyntheticEvent, useRef } from 'react';
import ReactDom from 'react-dom';
import styles from './PortalModal.module.scss';

interface IPortalModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  title?: ReactNode;
  children: ReactNode;
  noBackdrop?: boolean;
  stretchHeight?: boolean;
}

export function PortalModal(props: IPortalModalProps) {
  const modalRoot = document.getElementById('portal');
  const contentEl = useRef(null);
  const closeBtnEl = useRef(null);
  function onCloseHandler(e: SyntheticEvent) {
    if ((props.noBackdrop || e.target !== contentEl.current) && e.target !== closeBtnEl.current) {
      props.setIsOpen(true);
    } else {
      props.setIsOpen(false);
    }
  }
  return ReactDom.createPortal(
    <div
      ref={contentEl}
      onClick={onCloseHandler}
      className={classNames(styles.PortalModal, props.isOpen && styles.active, !props.noBackdrop && styles.backdrop)}
    >
      <div className={classNames(styles.PortalModal__Content, props.stretchHeight && styles.StretchHeight)}>
        {props.title && <h3 className={styles.PortalModal__Title}>{props.title}</h3>}
        <div className={styles.PortalModal__Body}>{props.children}</div>
        <button ref={closeBtnEl} className={styles.PortalModal__CloseBtn} type="button" onClick={() => props.setIsOpen(false)}></button>
      </div>
    </div>,
    modalRoot,
  );
}
